// extracted by mini-css-extract-plugin
export var Section = "Timeline-module--Section--9MgUK";
export var ImageWrap = "Timeline-module--ImageWrap--GU9Yp";
export var Image = "Timeline-module--Image--5riy2";
export var arrowLeft = "Timeline-module--arrowLeft--F9M+u";
export var arrowRight = "Timeline-module--arrowRight--ni4pP";